import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BigTipBox from './BigTipBox'
import SmallTipBox from './SmallTipBox'
import { VARIANTS } from '../../../constants'

class TipBox extends Component {
  render () {
    const {
      box,
      variant
    } = this.props

    if (variant === VARIANTS.BIG) {
      return <BigTipBox box={box}/>
    } else {
      return <SmallTipBox box={box}/>
    }
  }
}

TipBox.propTypes = {
  box: PropTypes.object.isRequired
}

export default TipBox
